import { gsap } from 'gsap';
import { init, enter } from '../animations';

export function pauseEnter(el) {
  const bg = el.querySelector('.ui-pause__bg');
  const banner = el.querySelector('.ui-pause__banner');
  const scoreTexts = el.querySelector('.game-score');
  const button = el.querySelector('.ui-pause__buttons .rounded-button');
  const tl = gsap.timeline();

  init.get('fade')(bg);
  init.get('banner')(banner);
  init.get('buttonCircular')(scoreTexts);
  init.get('buttonRounded')(button);

  tl.addLabel('start')
    .add(enter.get('fade')(bg, 0, 0.5), 'start')
    .add(enter.get('banner')(banner), 'start+=0.2')
    .add(enter.get('buttonCircular')(scoreTexts), 'start+=0.5')
    .add(enter.get('buttonRounded')(button), 'start+=0.8');

  return tl;
}

export function pauseLeave(el) {
  const tl = gsap.timeline();

  tl.addLabel('start')
    .to(el, { opacity: 0, duration: 0.5, ease: 'power3.easeOut' });

  return tl;
}
